<template>
  <v-card
    class="my-2"
    flat
    data-cy="branding-card"
  >
    <v-card-title class="py-2">
      <v-layout
        wrap
        align-center
      >
        <v-flex
          sm6
          xs6
        >
          <v-layout column>
            <div
              class="title"
              style="word-break: break-word"
            >
              {{ branding.name }}
            </div>
            <div
              v-if="branding.is_default"
              class="caption mt-1 msr--text"
            >
              {{ $t('brandingIsDefault') }}
            </div>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="$vuetify.breakpoint.smAndUp"
          sm3
        >
          <v-layout align-center>
            <div
              style="outline: 1px solid rgba(0, 0, 0, 0.08)"
              class="mr-2 transparency-checker-background small"
            >
              <div
                style="width: 24px; height: 24px"
                :style="{background: branding.color_primary}"
              />
            </div>
            <div
              style="outline: 1px solid rgba(0, 0, 0, 0.08)"
              class="mr-2 transparency-checker-background small"
            >
              <div
                style="width: 24px; height: 24px"
                :style="{background: branding.color_secondary}"
              />
            </div>
            <img
              v-if="branding.logo"
              style="max-width: 48px; max-height: 48px; object-fit: contain"
              :src="branding.logo"
              class="mr-2"
            >
          </v-layout>
        </v-flex>
        <v-flex
          sm3
          xs6
        >
          <v-layout
            align-center
            justify-end
          >
            <v-btn
              icon
              flat
              color="msr"
              class="ml-0 my-0"
              :disabled="!isEditable"
              :title="$t('edit')"
              @click="$emit('edit', branding)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              color="msr"
              class="my-0"
              :disabled="!isEditable"
              :title="$t('copy')"
              data-cy="branding-duplicate-btn"
              @click="$emit('copy', branding)"
            >
              <v-icon>content_copy</v-icon>
            </v-btn>
            <v-menu>
              <v-btn
                slot="activator"
                icon
                flat
                data-cy="actions-menu-btn"
                color="grey darken-1"
                class="my-0 mr-0"
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <!-- Make this the default-->
                <v-list-tile
                  v-if="showToggleDefaultButton"
                  @click="$emit('toggledefault', branding)"
                >
                  <v-list-tile-action>
                    <v-icon
                      :class="{
                        'grey--text': !branding.is_default,
                        'msr--text': branding.is_default,
                      }"
                    >
                      check_circle
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ $t('brandingToggleDefault') }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="showToggleDefaultButton" />
                <!-- Delete -->
                <v-list-tile
                  data-cy="branding-delete-btn"
                  :title="$t('remove')"
                  @click="$emit('delete', branding)"
                >
                  <v-list-tile-action>
                    <v-icon color="error">
                      delete
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ $t('remove') }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-divider v-if="showDivider" />
  </v-card>
</template>

<script>
export default {
  props: {
    branding: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    showDivider: {
      type: Boolean,
      default: false,
    },
    showToggleDefaultButton: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/BrandingCard.vue